(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-section-stacks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-stacks-look]');
  if (!root) return;

  var slides = Array.from(root.querySelectorAll('.stacks-look__slide'));
  var dots = Array.from(root.querySelectorAll('.stacks-look__dot'));
  var productRails = Array.from(root.querySelectorAll('.stacks-look__products-group'));
  var media = root.querySelector('[data-media]');

  var autoRotateId = null;
  var autoRotateDelay = 7000; // ~3 seconds

  function setActiveGroup(group) {
    group = String(group);

    slides.forEach(function (s) {
      s.classList.toggle('is-active', s.dataset.group === group);
    });

    dots.forEach(function (d) {
      var active = d.dataset.targetGroup === group;
      d.classList.toggle('is-active', active);
      d.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    productRails.forEach(function (p) {
      p.hidden = (p.dataset.group !== group);
    });
  }

  function resetCardsForGroup(group) {
    var panel = root.querySelector('.stacks-look__products-group[data-group="' + group + '"]');
    if (!panel) return;

    var cards = panel.querySelectorAll('[data-product-card]');
    cards.forEach(function (c) {
      c.removeAttribute('data-faded');
      c.classList.remove('is-active');
    });
  }

  function clearActiveHotspots() {
    var allHotspots = media.querySelectorAll('.thb-hotspot');
    allHotspots.forEach(function (h) {
      h.classList.remove('is-active');
    });
  }

  function stopAutoRotate() {
    if (autoRotateId) {
      clearInterval(autoRotateId);
      autoRotateId = null;
    }
  }

  function startAutoRotate() {
    stopAutoRotate();
    if (dots.length <= 1) return;

    autoRotateId = setInterval(function () {
      var currentDot = root.querySelector('.stacks-look__dot.is-active');
      var currentIndex = currentDot ? dots.indexOf(currentDot) : 0;
      if (currentIndex < 0) currentIndex = 0;

      var nextIndex = (currentIndex + 1) % dots.length;
      var nextDot = dots[nextIndex];
      var nextGroup = String(nextDot.dataset.targetGroup);

      setActiveGroup(nextGroup);
      resetCardsForGroup(nextGroup);
      clearActiveHotspots();
    }, autoRotateDelay);
  }

  // === NEW: central function to activate a card by handle + group ===
  function activateCardByHandle(handle, group, options) {
    options = options || {};
    var panel = root.querySelector('.stacks-look__products-group[data-group="' + group + '"]');
    if (!panel) return;

    var cards = Array.from(panel.querySelectorAll('[data-product-card]'));

    // Clear current state
    cards.forEach(function (c) {
      c.removeAttribute('data-faded');
      c.classList.remove('is-active');
    });

    var active = panel.querySelector('[data-product-card][data-handle="' + handle + '"]');
    if (!active) return;

    active.classList.add('is-active');

    cards.forEach(function (c) {
      if (c !== active) c.setAttribute('data-faded', '');
    });

    // Optional scroll on "real" selection (click), not on hover
    if (options.scrollIntoView) {
      active.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  // Init
  var firstPanel = productRails.find(function (p) { return !p.hidden; });
  if (firstPanel) {
    setActiveGroup(firstPanel.dataset.group);
    resetCardsForGroup(firstPanel.dataset.group);
  }
  startAutoRotate();

  // Dots -> change look
  dots.forEach(function (d) {
    d.addEventListener('click', function () {
      var group = d.dataset.targetGroup;
      setActiveGroup(group);
      resetCardsForGroup(group);
      clearActiveHotspots();
      startAutoRotate(); // restart timer after manual interaction
    });
  });

  // Hotspot -> click: select + fade others (existing behavior)
  media.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-select-handle]');
    if (!btn) return;

    stopAutoRotate(); // stop autoplay when user interacts

    var handle = btn.getAttribute('data-select-handle');
    var slide = btn.closest('.stacks-look__slide');
    if (!slide) return;

    var group = slide.dataset.group;

    setActiveGroup(group);
    clearActiveHotspots();
    btn.classList.add('is-active');

    activateCardByHandle(handle, group, { scrollIntoView: true });
  });

  // === NEW: Hotspot hover -> preview same as active (no scroll) ===
  media.addEventListener('mouseenter', function (e) {
    var btn = e.target.closest('[data-select-handle]');
    if (!btn) return;

    var handle = btn.getAttribute('data-select-handle');
    var slide = btn.closest('.stacks-look__slide');
    if (!slide) return;

    var group = slide.dataset.group;

    setActiveGroup(group);
    clearActiveHotspots();
    btn.classList.add('is-active');

    // Make matching card look "active" and fade the rest
    activateCardByHandle(handle, group, { scrollIntoView: false });
  }, true);

  // === NEW: Product card hover -> also behave like active ===
  productRails.forEach(function (rail) {
    rail.addEventListener('mouseenter', function (e) {
      var card = e.target.closest('[data-product-card]');
      if (!card) return;

      var group = rail.dataset.group;
      var handle = card.getAttribute('data-handle');
      if (!handle) return;

      // Just visually activate this card & fade others in this rail
      activateCardByHandle(handle, group, { scrollIntoView: false });
    }, true);
  });
});

  } catch(e) { console.error(e); }
})();
})();
